import React from "react";

function LoyaltyPoints({ currency }) {
  const user = JSON.parse(localStorage.getItem("rms-customer"));
  return (
    <div className="bg-[#eaecf9] w-full h-fit flex gap-16 p-6 rounded-lg shadow-lg">
      <div className="w-1/2 flex flex-col justify-between">
        <div>
          <h1 className="font-semibold text-lg">Loyalty Points</h1>
        </div>
        <div className="text-3xl font-semibold">
          <h2>Total Points - {user?.customer.loyalty_points || 0}</h2>
          <h2>
            Total {currency || "S.R"} -{" "}
            {(
              user?.customer.loyalty_points / user?.loyalty[0].convert_points ||
              0
            ).toFixed(2)}
          </h2>
        </div>
        <div>
          <h3 className="">active by admin side</h3>
        </div>
      </div>
      <div className="w-1/2">
        <img src="/assets/loyalty_reward.jpg" alt="" />
      </div>
    </div>
  );
}

export default LoyaltyPoints;
